import { Id } from '@nextforce/api'

const keys = {
  all: ['stores'],
  helper: ['helper'],
  details: (storeId: Id) => [...keys.all, storeId],
}

export default keys
